import { isString } from 'radash';

import { RxdbCollectionNameV2 } from '../RxdbCollectionNameV2';
import { Failed, isFailed } from '../Synchronizable/SyncResult';

export const reason = 'Parent Failure';

export interface ParentsFailed extends Failed {
  failure: typeof reason;
  failedParents: RxdbCollectionNameV2[];
}

export function isParentsFailed(obj: unknown): obj is ParentsFailed {
  if (!isFailed(obj)) return false;
  if (obj.failure !== reason) return false;
  const possible = obj as Partial<ParentsFailed>;
  if (!Array.isArray(possible.failedParents)) return false;
  return possible.failedParents.every(isString);
}
